export const Assets = {
    primaryColor: "#04F9CC",
    primaryColorHover: "#09C3A1",
    secondaryColor: "#2A2A2A",
    disabledColor: "#ccc",
    backgroundColor: "#000",
    loadingBlack: "/assets/images/load-black.gif",
    loadingWhite: "/assets/images/load-white.gif",
    redColor: "#D11201",
    redColorHover: "#A61406",
    backgroundForm: "rgb(17, 17, 17)",
    borderRadiusForm: "24px",
    logo: "/assets/images/logo.svg",
    heightInput: "45px",    
}